import "../../utils/tailwind.css";
import cx from "../../utils/tailwind-merge";
import CircleIcon from "../svg/circle";
import { useField, useFormikContext } from "formik";
import FormError from "../form-error";

export default function SwitchComponent({ checked, onChange }) {
  const isChecked = checked;

  const handleToggle = () => {
    onChange && onChange(!isChecked);
  };

  return (
    <div
      className={cx(
        "relative w-[45px] h-[20px] rounded-[32px] flex items-center cursor-pointer transition-all",
        isChecked ? "!bg-[#6A0BB0]" : "bg-gray-300"
      )}
      role="button"
      tabIndex={0}
      onClick={handleToggle}>
      <div
        className={cx(
          "absolute left-1 flex items-center justify-center w-[15px] h-[15px] bg-white rounded-full shadow-md transition-all",
          isChecked && "translate-x-6"
        )}>
        <CircleIcon className="w-2 h-2 text-white" />
      </div>
    </div>
  );
}

export function FormikSwitch(props) {
  const { name, classNames = {}, onChange, ...restProps } = props;
  const [field, meta, { setValue }] = useField(name);
  const { submitCount } = useFormikContext();

  const isError = submitCount > 0 && !!meta.error;
  const helperText = isError ? meta.error : "";

  const handleChange = (checked) => {
    setValue(checked);
    onChange && onChange(checked);
  };

  return (
    <>
      <SwitchComponent
        {...field}
        {...restProps}
        checked={field.value}
        onChange={handleChange}
      />
      <FormError
        show={isError}
        message={helperText}
        className={classNames.error}
      />
    </>
  );
}
